import React, { useState, useEffect } from 'react';
import styles from './Filter.module.css';

const Filter = ({ isOpen, onClose, onApply, categories = [], loading = false }) => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');

    // Reset values when modal opens
    useEffect(() => {
        if (isOpen) {
            setMinPrice('0');
            setMaxPrice('10000000');
            setSelectedCategory('all');
        }
    }, [isOpen]);

    const handleReset = () => {
        setSelectedCategory('all');
        setMinPrice('0');
        setMaxPrice('10000000');
    };

    const handleApplyFilters = () => {
        onApply({
            category: selectedCategory,
            minPrice: Number(minPrice || 0),
            maxPrice: Number(maxPrice || 10000000),
        });
    };

    const handleMinPriceChange = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        if (value === '' || Number(value) <= Number(maxPrice)) {
            setMinPrice(value);
        }
    };

    const handleMaxPriceChange = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        if (value === '' || Number(value) >= Number(minPrice)) {
            setMaxPrice(value);
        }
    };

    return (
        <div className={`${styles.modalOverlay} ${isOpen ? styles.open : ''}`}>
            <div className={styles.modalContent}>
                <header className={styles.header}>
                    <button onClick={onClose} className={styles.backButton}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <h2 className={styles.title}>Filter</h2>
                    <button onClick={handleReset} className={styles.resetButton}>Reset all</button>
                </header>
                <main className={styles.main}>
                    <div className={styles.filterContent}>
                        <div className={styles.filterSection}>
                            <label className={styles.label}>Category</label>
                            <div className={styles.selectWrapper}>
                                <select 
                                    value={selectedCategory}
                                    onChange={(e) => setSelectedCategory(e.target.value)}
                                    className={styles.select}
                                >
                                    <option value="all">All Categories</option>
                                    {categories.map(cat => (
                                        <option key={cat._id} value={cat._id}>
                                            {cat.category_name}
                                        </option>
                                    ))}
                                </select>
                                <svg className={styles.selectArrow} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 9L12 15L18 9" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span className={styles.totalProducts}>
                                {selectedCategory === 'all' 
                                    ? categories.reduce((sum, cat) => sum + (cat.number_of_product || 0), 0)
                                    : categories.find(cat => cat._id === selectedCategory)?.number_of_product || 0} products available
                            </span>
                        </div>
                        <div className={styles.filterSection}>
                            <label className={styles.label}>Min Price</label>
                            <input 
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={minPrice}
                                onChange={handleMinPriceChange}
                                placeholder="0"
                                className={styles.input}
                            />
                        </div>
                        <div className={styles.filterSection}>
                            <label className={styles.label}>Max Price</label>
                            <input 
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={maxPrice}
                                onChange={handleMaxPriceChange}
                                placeholder="10000000"
                                className={styles.input}
                            />
                        </div>
                    </div>
                </main>
                <footer className={styles.footer}>
                    <button onClick={onClose} className={styles.cancelButton}>Cancel</button>
                    <button onClick={handleApplyFilters} className={styles.applyButton}>Apply</button>
                </footer>
            </div>
        </div>
    );
};

export default Filter; 